"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateMailchimpSyncStatus = exports.setMailchimpSyncStatusActionType = exports.setMailchimpSyncStatus = exports.loadMailchimpSyncStatus = exports.FetchMailchimpSyncStatus = exports.FetchMailchimpSyncStatusActionType = exports.UpdateEspSync = exports.UpdateEspSyncActionType = exports.updateEspSync = exports.RemoveLastEspSyncError = exports.RemoveLastEspSyncErrorActionType = exports.removeLastEspSyncError = exports.loadEspSync = exports.FetchEspSync = exports.FetchEspSyncActionType = exports.EspSyncActionType = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _I18n = _interopRequireDefault(require("I18n"));

var _fluxActions = require("flux-actions");

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var _actions = require("settings-ui-sdk/utils/actions");

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-sdk/utils/namespacedKeyMirror"));

var _constants = require("./constants");

var EspSyncActionType = (0, _namespacedKeyMirror.default)({
  FETCH_ESP_SYNC: null,
  LOAD_ESP_SYNC: null,
  REMOVE_LAST_ESP_SYNC_ERROR: null,
  UPDATE_ESP_SYNC: null,
  FETCH_MAILCHIMP_SYNC_STATUS: null,
  LOAD_MAILCHIMP_SYNC_STATUS: null,
  SET_MAILCHIMP_SYNC_STATUS: null
}, _constants.ESP_SYNC);
exports.EspSyncActionType = EspSyncActionType;
var FetchEspSyncActionType = (0, _actions.createRequestTypes)(EspSyncActionType.FETCH_ESP_SYNC);
exports.FetchEspSyncActionType = FetchEspSyncActionType;
var FetchEspSync = (0, _actions.createRequestActions)(FetchEspSyncActionType);
exports.FetchEspSync = FetchEspSync;
var loadEspSync = (0, _fluxActions.createAction)(EspSyncActionType.LOAD_ESP_SYNC);
exports.loadEspSync = loadEspSync;
var removeLastEspSyncError = (0, _fluxActions.createAction)(EspSyncActionType.REMOVE_LAST_ESP_SYNC_ERROR);
exports.removeLastEspSyncError = removeLastEspSyncError;
var RemoveLastEspSyncErrorActionType = (0, _actions.createRequestTypes)(EspSyncActionType.REMOVE_LAST_ESP_SYNC_ERROR);
exports.RemoveLastEspSyncErrorActionType = RemoveLastEspSyncErrorActionType;
var RemoveLastEspSyncError = (0, _actions.createRequestActions)(RemoveLastEspSyncErrorActionType, {
  successMetaCreator: function successMetaCreator() {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(RemoveLastEspSyncErrorActionType.base, _RequestStatusTypes.default.SUCCEEDED), (0, _actions.createSuccessNotificationMeta)(_I18n.default.text('marketing.sdk.espSync.removeLastError.success')));
  },
  failureMetaCreator: function failureMetaCreator() {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(RemoveLastEspSyncErrorActionType.base, _RequestStatusTypes.default.FAILED), (0, _actions.createDangerNotificationMeta)(_I18n.default.text('marketing.sdk.espSync.removeLastError.failure')));
  }
});
exports.RemoveLastEspSyncError = RemoveLastEspSyncError;
var updateEspSync = (0, _fluxActions.createAction)(EspSyncActionType.UPDATE_ESP_SYNC, (0, _actions.mapPayloadTo)('data'));
exports.updateEspSync = updateEspSync;
var UpdateEspSyncActionType = (0, _actions.createRequestTypes)(EspSyncActionType.UPDATE_ESP_SYNC);
exports.UpdateEspSyncActionType = UpdateEspSyncActionType;
var UpdateEspSync = (0, _actions.createRequestActions)(UpdateEspSyncActionType, {
  successMetaCreator: function successMetaCreator() {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(UpdateEspSyncActionType.base, _RequestStatusTypes.default.SUCCEEDED), (0, _actions.createSuccessNotificationMeta)(_I18n.default.text('marketing.sdk.espSync.update.success')));
  },
  failureMetaCreator: function failureMetaCreator() {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(UpdateEspSyncActionType.base, _RequestStatusTypes.default.FAILED), (0, _actions.createDangerNotificationMeta)(_I18n.default.text('marketing.sdk.espSync.update.failure')));
  }
});
exports.UpdateEspSync = UpdateEspSync;
var FetchMailchimpSyncStatusActionType = (0, _actions.createRequestTypes)(EspSyncActionType.FETCH_MAILCHIMP_SYNC_STATUS);
exports.FetchMailchimpSyncStatusActionType = FetchMailchimpSyncStatusActionType;
var FetchMailchimpSyncStatus = (0, _actions.createRequestActions)(FetchMailchimpSyncStatusActionType);
exports.FetchMailchimpSyncStatus = FetchMailchimpSyncStatus;
var loadMailchimpSyncStatus = (0, _fluxActions.createAction)(EspSyncActionType.LOAD_MAILCHIMP_SYNC_STATUS);
exports.loadMailchimpSyncStatus = loadMailchimpSyncStatus;
var setMailchimpSyncStatus = (0, _fluxActions.createAction)(EspSyncActionType.SET_MAILCHIMP_SYNC_STATUS, function (payload) {
  return payload;
});
exports.setMailchimpSyncStatus = setMailchimpSyncStatus;
var setMailchimpSyncStatusActionType = (0, _actions.createRequestTypes)(EspSyncActionType.SET_MAILCHIMP_SYNC_STATUS);
exports.setMailchimpSyncStatusActionType = setMailchimpSyncStatusActionType;
var updateMailchimpSyncStatus = (0, _actions.createRequestActions)(setMailchimpSyncStatusActionType, {
  failureMetaCreator: function failureMetaCreator(error, props) {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(setMailchimpSyncStatusActionType.base, _RequestStatusTypes.default.FAILED), (0, _actions.createDangerNotificationMeta)(_I18n.default.text("marketing.espSync.status.mailchimp.meta.failure" + (props ? 'On' : 'Off'))));
  }
});
exports.updateMailchimpSyncStatus = updateMailchimpSyncStatus;